module.exports = __webpack_public_path__ + "media/fonts/alternate-gothic-no3-regular-webfont-66707f5b082f250364b2d465514d4f4f.eot";